export default __webpack_public_path__ + "static/media/user_profile.2ccb18fa.png";